"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.StatelessMenu = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var MenuDropdown_1 = require("./MenuDropdown");
var StatelessMenu_module_scss_1 = __importDefault(require("./StatelessMenu.module.scss"));
var StatelessMenu = function (_a) {
    var _b = _a.align, align = _b === void 0 ? "left" : _b, _c = _a.dropdownWidth, dropdownWidth = _c === void 0 ? "default" : _c, _d = _a.autoHide, autoHide = _d === void 0 ? "on" : _d, automationId = _a.automationId, dropdownId = _a.dropdownId, children = _a.children, portalSelector = _a.portalSelector, isMenuVisible = _a.isMenuVisible, toggleMenuDropdown = _a.toggleMenuDropdown, hideMenuDropdown = _a.hideMenuDropdown, renderButton = _a.renderButton, onClick = _a.onClick;
    var _e = (0, react_1.useState)(null), referenceElement = _e[0], setReferenceElement = _e[1];
    var portalSelectorElementRef = (0, react_1.useRef)(null);
    var menuButton = renderButton({
        onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleMenuDropdown();
        },
        onMouseDown: function (e) {
            return e.preventDefault();
        },
        "aria-haspopup": true,
        "aria-expanded": isMenuVisible
    });
    (0, react_1.useEffect)(function () {
        portalSelectorElementRef.current = portalSelector
            ? document.querySelector(portalSelector)
            : null;
    }, [portalSelector]);
    (0, react_1.useEffect)(function () {
        if (portalSelector && !portalSelectorElementRef.current) {
            // eslint-disable-next-line no-console
            console.warn("The portal could not be created using the selector: " + portalSelector);
        }
    }, [portalSelectorElementRef, portalSelector]);
    var menu = isMenuVisible ? (react_1["default"].createElement(MenuDropdown_1.MenuDropdown, { referenceElement: referenceElement, align: align, hideMenuDropdown: hideMenuDropdown, width: dropdownWidth, id: dropdownId, autoHide: autoHide }, children)) : null;
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    react_1["default"].createElement("div", { "data-automation-id": automationId, onClick: onClick },
        react_1["default"].createElement("div", { className: StatelessMenu_module_scss_1["default"].buttonWrapper, ref: setReferenceElement }, menuButton),
        portalSelector && portalSelectorElementRef.current
            ? react_dom_1["default"].createPortal(menu, portalSelectorElementRef.current)
            : menu));
};
exports.StatelessMenu = StatelessMenu;
exports.StatelessMenu.displayName = "StatelessMenu";
//# sourceMappingURL=StatelessMenu.js.map